import styles from './FleetSalesVideoHighlightsSection.scss';
import Card from './VideoHighlightsSectionCard/VideoHighlightsSectionCard';
export default function FleetSalesVideoHighlightsSection({ fields }) {
  return (
    <div className={'container FleetSalesVideoHighlightsSection'}>
      <div className={'wrapper'} data-aos="fade-up">
        {fields?.Item?.map((card, index) => {
          return <Card key={index} card={card} />;
        })}
      </div>
    </div>
  );
}
